import script from "./queryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./queryModal.vue?vue&type=script&setup=true&lang=js"

import "./queryModal.vue?vue&type=style&index=0&id=881878c8&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-881878c8"]])

export default __exports__